import type { SchoolSettings } from "shared/types/schoolSettings.types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const schoolSettingsFromDto = (dto: any): SchoolSettings => ({
  rootSettings: {
    schoolName: dto.root_settings.school_name,
    sso: dto.root_settings.sso,
    ssoAuthsource: dto.root_settings.sso_authsource,
    brinCodes: dto.root_settings.brin_codes,
    modules: dto.root_settings.modules,
    tool: dto.root_settings.tool,
    startSchoolyear: new Date(dto.root_settings.start_schoolyear),
    licenseExpiryDate: new Date(dto.root_settings.license_expiry_date),
    advisor: dto.root_settings.advisor,
    type: dto.root_settings.type,
    studentRatings: dto.root_settings.student_ratings,
    groupMeeting: dto.root_settings.group_meeting,
  },
  schoolSettings: {
    lvs: dto.school_settings.lvs,
    autoSync: dto.school_settings.auto_sync,
    manageData: dto.school_settings.manage_data,
    studentsAmount: dto.school_settings.students_amount,
    studentLicenseAmount: dto.school_settings.student_license_amount,
    studentsWithoutProfilePicture:
      dto.school_settings.students_without_profile_picture,
    managers: dto.school_settings.managers,
  },
  emailSettings: {
    emailHelp: dto.email_settings.email_help,
    emailSync: dto.email_settings.email_sync,
    emailLicense: dto.email_settings.email_license,
  },
  ratingSettings: {
    weakRemarkRequired: dto.rating_settings.weak_remark_required,
    weakActionRequired: dto.rating_settings.weak_action_required,
    moderateRemarkRequired: dto.rating_settings.moderate_remark_required,
    moderateActionRequired: dto.rating_settings.moderate_action_required,
    goodRemarkRequired: dto.rating_settings.good_remark_required,
    goodActionRequired: dto.rating_settings.good_action_required,
    excellentRemarkRequired: dto.rating_settings.excellent_remark_required,
    excellentActionRequired: dto.rating_settings.excellent_action_required,
  },
  studentMeetingSettings: {
    enabled: dto.student_meeting_settings.enabled,
    license: dto.student_meeting_settings.license,
    licenseUsed: dto.student_meeting_settings.license_used,
    settings: {
      enableRapportGrade:
        dto.student_meeting_settings.settings.enable_rapport_grade,
      enableSeGrade: dto.student_meeting_settings.settings.enable_se_grade,
      studentGradesEndpoints:
        dto.student_meeting_settings.settings.student_grades_endpoints.map(
          (endpoint: { label: string; value: string }) => ({
            label: endpoint.label,
            value: endpoint.value,
          }),
        ),
      allowStudentRatings:
        dto.student_meeting_settings.settings.allow_student_ratings === 1,
      studentCheckIn: dto.student_meeting_settings.settings.student_check_in,
    },
  },
  groupMeetingSettings: {
    settings: {
      minTeacherMeetingPercentage:
        dto.group_meeting_settings.settings.min_teacher_meeting_percentage,
    },
  },
  conversationSettings: {
    conversationsEnabled: dto.conversation_settings.conversations_enabled,
  },
  aiSettings: {
    allowAi: dto.ai_settings.allow_ai,
  },
  portfolioSettings: {
    enabled: dto.portfolio_settings.enabled,
    portfolioAmount: dto.portfolio_settings.portfolio_amount,
    settings: {
      maxSkillsPerActivity:
        dto.portfolio_settings.settings.max_skills_per_activity,
      allowPortfolioReferences:
        dto.portfolio_settings.settings.allow_portfolio_references,
      allowPortfolioChats:
        dto.portfolio_settings.settings.allow_portfolio_chats,
      portfolioActivityHoursEducationLevels:
        dto.portfolio_settings.settings
          .portfolio_activity_hours_education_levels,
      portfolioReferenceEducationLevels:
        dto.portfolio_settings.settings.portfolio_reference_education_levels,
      disallowedFileTypes:
        dto.portfolio_settings.settings.disallowed_file_types.map(
          (fileType: { label: string; allowed: boolean }) => ({
            label: fileType.label,
            allowed: fileType.allowed,
          }),
        ),
      allowSubActivities: dto.portfolio_settings.settings.allow_sub_activities,
      allowPortfolioTags: dto.portfolio_settings.settings.allow_portfolio_tags,
      allowPortfolioSkills:
        dto.portfolio_settings.settings.allow_portfolio_skills,
      allowSkillCategories:
        dto.portfolio_settings.settings.allow_skill_categories,
      allowTaskRatings: dto.portfolio_settings.settings.allow_task_ratings,
      allowedUserRolesToCreateTasks:
        dto.portfolio_settings.settings.allowed_user_roles_to_create_tasks,
    },
  },
  learningObjectiveSettings: {
    enabled: dto.learning_objective_settings.enabled,
    settings: {
      allowedUserRolesToTrackProgress:
        dto.learning_objective_settings.settings
          .allowed_user_roles_to_track_progress,
      allowClusterChats:
        dto.learning_objective_settings.settings.allow_cluster_chats,
      maxRating: dto.learning_objective_settings.settings.max_rating,
      scheduleSource: dto.learning_objective_settings.settings.schedule_source,
    },
  },
});
